import React from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import { ReactComponent as MusicIcon } from "../../assets/playIcon.svg";
import { ReactComponent as LyricsIcon } from "../../assets/lyricsIcon.svg";
import ChordsIcons from "../../assets/chordsIcon.png";

import { useNavigate } from "react-router-dom";

import "./styles.css";

function BandCard({
  linkToMp4,
  linkToChords,
  bandName,
  bandImage,
  songName,
  composer,
  author,
  id,
}) {

  const navigate = useNavigate();

  const navigateToSongPlay = () => {
    navigate(`/song/${id}#media`);
  };

  const navigateToLyrics = () => {
    navigate(`/song/${id}#lyrics`);
  };

  const navigateToChords = () => {
    navigate(`/song/${id}#chords`);
  };

  return (
    <>
      <Row className="band-row my-2 py-2 mx--1">
        <Col
          xs={4}
          md={1}
          className="d-flex align-items-center justify-content-center"
          onClick={() => {
            navigate(`/song/${id}#top`);
          }}
        >
          <img src={bandImage} alt={`${bandName}`} className="band-image-2" />
        </Col>

        <Col
          xs={8}
          md={3}
          className="d-flex align-items-center p-xs-0 band-details"
          onClick={() => {
            navigate(`/song/${id}#top`);
          }}
        >
          <div>
            <p>{songName}</p>
            <p>{bandName}</p>
          </div>
        </Col>

        <Col
          md={2}
          className="d-flex align-items-center justify-content-center md-hidden"
          onClick={() => {
            navigate(`/song/${id}#top`);
          }}
        >
          <p className="rtl"> {`ألحان: ${composer} `}</p>
        </Col>

        <Col
          md={2}
          className="d-flex align-items-center justify-content-center md-hidden"
          onClick={() => {
            navigate(`/song/${id}#top`);
          }}
        >
          <p className="rtl">{`كلمات:  ${author} `}</p>
        </Col>

        <Col
          className="d-flex align-items-center lyrics"
          // class="lyrics"
            xs={4}
            md={1}
        >
          <Button
            variant="link"
            className="d-inline-block icon-button"
            onClick={() => {
              navigateToLyrics();
            }}
          >
            <LyricsIcon className="icon lyrics-icon" />
            <p className="text-center icon-text">Lyrics</p>
          </Button>
        </Col>

        {linkToMp4 /** position removed so I can see the play button on each card has a song link inside */ && (
          <Col
            className="d-flex align-items-center justify-content-center play"
            // class="play"
            xs={4}
            md={1}
          >
            <Button
              variant="link"
              className="d-inline-block icon-button"
              onClick={() => {
                navigateToSongPlay();
              }}
            >
              <MusicIcon className="icon music-icon" />
              <p className="text-center icon-text">Play</p>
            </Button>
          </Col>
        )}

        {linkToChords && (
          <Col className="d-flex align-items-center fixed-flex chords"
            xs={4}
            md={1}
          >
            <Button
              variant="link"
              className="d-inline-block icon-button"
              onClick={() => {
                navigateToChords();
              }}
            >
              {/* <ChordsIcons className="icon chords-icon" /> */}
              <img
                src={ChordsIcons}
                style={{ width: "50px", filter: 'brightness(0) invert(1)'}}
                className="icon chords-icon"
              />
              <p className="text-center icon-text">Chords</p>
            </Button>
          </Col>
        )}
      </Row>
    </>
  );
}

export { BandCard };
